import { render, staticRenderFns } from "./gfx3d.vue?vue&type=template&id=3b374844&scoped=true&"
import script from "./gfx3d.vue?vue&type=script&lang=js&"
export * from "./gfx3d.vue?vue&type=script&lang=js&"
import style0 from "./gfx3d.vue?vue&type=style&index=0&id=3b374844&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b374844",
  null
  
)

export default component.exports